import { Spinner } from "react-bootstrap";

export default function Progress(props) {
    return (
      <div style={{ 
        background: '#00000010',
        width: '100vw',
        height: '100vh',
        display: props.show ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1200
      }}>
        <Spinner animation="border" role="status" variant={props.variant || 'primary'}>
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }